import {Avatar, Input, Radio} from 'antd'
import _ from 'lodash'
import useTranslate from 'modules/local/useTranslate'
import React, {useEffect, useRef, useState} from 'react'
import {RiSearch2Line} from 'react-icons/ri'
import {lookup_lookupInfoByValue_Api} from '../../apis'
import useAsyncAction from '../../modules/asyncCache/useAsyncAction'
import DrawDialog from "../drawer/dialog/DrawDialog";
import {renderIf, renderIfElse} from "../../views/Shared";
import {IdentifierTypes} from "../../views/AppLocals/appFieldTypes";
import getAvatar from "../../helpers/getAvatar";
import {BsPersonFill} from "react-icons/bs";
import getTitle from "../../helpers/getTitle";
import getAliasName from "../../helpers/getAliasName";
import {Link} from "react-router-dom";
import getLinkToDetail from "../../helpers/getLinkToDetail";
import {GoDotFill} from "react-icons/go";

const UserLookupComponent = ({
                                 handleApply,
                                 children
                             }) => {
    const t = useTranslate()
    const emailInputRef = useRef();
    const idInputRef = useRef();
    const [userInfo, setUserInfo] = useState()
    const [type, setType] = useState('email')
    const {
        response,
        success,
        isLoading,
        handleAsyncAction: lookupInfo,
    } = useAsyncAction({
        apiInfo: lookup_lookupInfoByValue_Api,
    })

    useEffect(() => {
        if (success) {
            const userInfo = _.get(response, 'data', {})
            setUserInfo(userInfo)
        } else {
            setUserInfo({})
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [success, response])

    const {owner, email} = userInfo ?? {}

    return (
        <DrawDialog
            width={600}
            component={children}
            title={
                <div className="text-center font-bold text-color-000 uppercase tracking-wide">
                    {t('account lookup')}
                </div>
            }>
            {(isToggle, toggle) => {
                return isToggle && (
                    <div className="flex flex-col gap-6">
                        <div className="flex flex-col gap-4">
                            <div className="mx-auto">
                                <Radio.Group
                                    defaultValue={type}
                                    optionType="button"
                                    buttonStyle="solid"
                                    className="custom-radio-button"
                                    onChange={(e) => {
                                        setType(e.target.value);
                                        setUserInfo({})
                                    }}>
                                    <Radio.Button value="email">
                                        {t('email')}
                                    </Radio.Button>
                                    <Radio.Button value="identifier-type">
                                        {t('identifier code')}
                                    </Radio.Button>
                                </Radio.Group>
                            </div>
                            {renderIfElse(
                                type === 'email',
                                <div className="flex flex-col gap-1">
                                <span className="uppercase text-sm font-semibold text-color-300 tracking-wide mb-1">
                                    {t('email')}
                                </span>
                                    <Input.Search
                                        allowClear={true}
                                        placeholder={t('email placeholder')}
                                        ref={emailInputRef}
                                        onSearch={(value) => {
                                            if (!!value) {
                                                lookupInfo({}, {
                                                    search_type: 'user',
                                                    input_type: 'email',
                                                    input_value: value
                                                })
                                            }
                                        }}
                                        enterButton={
                                            <RiSearch2Line
                                                onClick={() => {
                                                    if (emailInputRef.current) {
                                                        lookupInfo({}, {
                                                            search_type: 'user',
                                                            input_type: 'email',
                                                            input_value: emailInputRef.current.input.value
                                                        })
                                                    }
                                                }}
                                            />
                                        }
                                    />
                                </div>,
                                <div className="flex flex-col gap-1">
                                <span className="uppercase text-sm font-semibold text-color-300 tracking-wide mb-1">
                                    {t('identifier code')}
                                </span>
                                    <div className="flex items-center gap-3">
                                        <Radio.Group
                                            defaultValue={type}
                                            onChange={(e) => setType(e.target.value)}
                                            className="custom-radio-button-sm whitespace-no-wrap"
                                            optionType="button"
                                            buttonStyle="solid">
                                            {Object.values(IdentifierTypes).map((e, i) => (
                                                <Radio.Button key={i} value={e.value} style={{padding: '6px 8px', height: 32}}>
                                                    {t(e.label)}
                                                </Radio.Button>
                                            ))}
                                        </Radio.Group>
                                        <Input.Search
                                            allowClear={true}
                                            placeholder={t('ex: id code')}
                                            ref={idInputRef}
                                            onSearch={(value) => {
                                                if (!!value) {
                                                    lookupInfo({}, {
                                                        search_type: 'user',
                                                        input_type: 'identifier_code',
                                                        input_value: value
                                                    })
                                                }
                                            }}
                                            enterButton={
                                                <RiSearch2Line
                                                    onClick={() => {
                                                        if (idInputRef.current) {
                                                            lookupInfo({}, {
                                                                search_type: 'user',
                                                                input_type: 'identifier_code',
                                                                input_value: idInputRef.current.input.value
                                                            })
                                                        }
                                                    }}
                                                />
                                            }
                                        />
                                    </div>
                                </div>
                            )}
                        </div>
                        {renderIfElse(
                            !isLoading,
                            renderIf(
                                userInfo?.name,
                                <div className="flex flex-col gap-2">
                                    <div className="flex items-center gap-2">
                                        <GoDotFill size={12} className="text-color-400"/>
                                        <span className="text-color-300 italic">
                                            {renderIfElse(
                                                type === "email",
                                                t('this email address is associated with the account'),
                                                t('this identifier is linked to the account')
                                            )} {' : '}
                                        </span>
                                    </div>
                                    <div className="py-2 flex items-center gap-2 custom-render-border">
                                        <Avatar
                                            size={40}
                                            src={getAvatar(owner)}
                                            icon={<BsPersonFill size={18} className="text-color-500"/>}
                                            className="flex flex-center background-200"
                                        />
                                        <div className="flex flex-col flex-1">
                                            <Link to={getLinkToDetail(owner)} className="font-bold text-color-000 no-underline">
                                                {renderIf(
                                                    getAliasName(owner, 'patron_saint'),
                                                    <span className="mr-1 font-medium text-sm text-color-400 italic capitalize">
                                                        {getAliasName(owner, 'patron_saint') || ''}
                                                    </span>
                                                )}
                                                {getTitle(owner)}
                                            </Link>
                                            <span style={{ fontSize: 11 }} className="text-color-500 italic leading-tight tracking-widest">
                                                {email}
                                            </span>
                                        </div>
                                        <div
                                            onClick={() => {
                                                handleApply({...userInfo});
                                                if (_.isFunction(toggle)) toggle();
                                            }}
                                            style={{ padding: '2px 10px', fontSize: 11 }}
                                            className="bg-primary-50 hover:bg-primary-100 rounded-md font-medium text-primary cursor-pointer">
                                            {t('choose')}
                                        </div>
                                    </div>
                                </div>
                            ),
                            <div className="text-sm text-color-500 italic">
                                {`${t('please wait a moment')}...`}
                            </div>
                        )}
                    </div>
                )
            }}
        </DrawDialog>
    )
}

export default UserLookupComponent
